import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { Box, Typography } from "@mui/material";

export const SectionHeader: FC<ISectionHeaderProps> = ({
  title,
  endAdornment,
}) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.listTitleContainer}>
      <Typography variant="HD3" color="primary.main">
        {title}
      </Typography>
      {endAdornment}
    </Box>
  );
};

export interface ISectionHeaderProps {
  title: string;
  endAdornment?: React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  listTitleContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(2),
  },
}));
